
import { supabase } from '@/integrations/supabase/client';

export const logActivityEvent = async (eventData: {
  entity_type: string;
  entity_id: string;
  user_name: string;
  action: string;
  details?: any;
  store_id: string;
}) => {
  try {
    const { data, error } = await supabase.from('activity_logs').insert([
      {
        entity_type: eventData.entity_type,
        entity_id: eventData.entity_id,
        user_name: eventData.user_name,
        action: eventData.action,
        details: eventData.details || {},
        store_id: eventData.store_id,
      },
    ]);

    if (error) {
      console.error('Error logging activity:', error);
    }

    return data;
  } catch (err) {
    console.error('Activity logging error:', err);
    return null;
  }
};

export const logMenuItemUpdated = async (
  menuItemId: string,
  storeId: string,
  changes: Record<string, [any, any]>
) => {
  return logActivityEvent({
    entity_type: 'menu_item',
    entity_id: menuItemId,
    user_name: 'Admin', // In a real app, get this from auth context
    action: 'menu_item_updated',
    details: changes,
    store_id: storeId,
  });
};

// Add missing store logging functions
export const logStoreCreated = async (
  storeId: string,
  storeData: Record<string, any>
) => {
  return logActivityEvent({
    entity_type: 'store',
    entity_id: storeId,
    user_name: 'Admin',
    action: 'store_created',
    details: storeData,
    store_id: storeId,
  });
};

export const logStoreUpdated = async (
  storeId: string,
  changes: Record<string, [any, any]>
) => {
  return logActivityEvent({
    entity_type: 'store',
    entity_id: storeId,
    user_name: 'Admin',
    action: 'store_updated',
    details: changes,
    store_id: storeId,
  });
};

export const logStoreDeleted = async (
  storeId: string,
  storeData: Record<string, any>
) => {
  return logActivityEvent({
    entity_type: 'store',
    entity_id: storeId,
    user_name: 'Admin',
    action: 'store_deleted',
    details: storeData,
    store_id: storeId,
  });
};

// Add staff attendance logging
export const logAttendanceEvent = async (
  staffId: string,
  storeId: string,
  action: string,
  details?: any
) => {
  return logActivityEvent({
    entity_type: 'attendance',
    entity_id: staffId,
    user_name: 'Admin',
    action,
    details,
    store_id: storeId,
  });
};

export const fetchActivityLogs = async (
  storeId: string,
  entityType?: string,
  limit: number = 50
) => {
  try {
    let query = supabase
      .from('activity_logs')
      .select('*')
      .eq('store_id', storeId)
      .order('created_at', { ascending: false })
      .limit(limit);

    if (entityType) {
      query = query.eq('entity_type', entityType);
    }

    const { data, error } = await query;

    if (error) {
      console.error('Error fetching activity logs:', error);
      return [];
    }

    return data;
  } catch (err) {
    console.error('Activity log fetch error:', err);
    return [];
  }
};
